import React from 'react';
import "./styles.css";
/**
 * @function PageLayoutContainer 
 * @param {React.Component} children - React components that's being wrapped by the page layout container.
 * @returns {React.Component}
 * @example
 * <PageLayoutContainer>
 *  <LeftColumnContainer>
 *    <h1>Left content</h1>
 *  </LeftColumnContainer>
 *  <RightColumnContainer>
 *    <h1>Right content</h1>
 *  </RightColumnContainer>
 * </PageLayoutContainer>
 */
export default function PageLayoutContainer(props) {
  return (
    <div className="column-container flex-container justify-center flex-horizontal page-layout-container">
      {props.children}
    </div>
  );
}